<mat-card *ngIf="pageData">
    <mat-card-content>
        <h2 class="mb-0 info-title">{{pageData.title}}</h2>

        <div *ngIf="isLoaded && jobsItems.length" class="carousel-with-navigation">
            <swiper-container 
                #carousel 
                space-between="24" 
                pagination="true" 
                pagination-clickable="true"
                [breakpoints]="breakpoints" 
                class="carousel"
            >
                <swiper-slide *ngFor="let job of jobsItems">
                    <app-career-lobby-position-item [cardData]="job" [layoutData]="pageData.layoutData"></app-career-lobby-position-item>
                </swiper-slide>
            </swiper-container>

            <div *ngIf="jobsItems.length > 3" class="d-phone-none">
                <button class="button-prev" [ngClass]="{ locked: lockPrev }" (click)="prevSlide()">
                  <mat-icon [svgIcon]="'prev-2'" class="square-icon button-icon"></mat-icon>
                </button>
                <button class="button-next" [ngClass]="{ locked: lockNext }" (click)="nextSlide()">
                  <mat-icon [svgIcon]="'next-2'" class="square-icon button-icon"></mat-icon>
                </button>
            </div>
        </div>
        <div *ngIf="!isLoaded" class="preloader--mini">
            <div class="preloader__icon">
                <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
            </div>
        </div>

        <div *ngIf="pageData.linkToCareerCatalogUrl" class="text-center mt-1">
            <app-portal-button [target]="pageData.linkToCareerCatalogTarget" [link]="pageData.linkToCareerCatalogUrl"
                classes="w-phone-100" color="primary" [title]="pageData.linkToCareerCatalogText" />
        </div>
    </mat-card-content>
</mat-card>